// Local-only development helper for testing the homepage demo without live API calls.
//
// To use:
//   1. Set USE_DEMO_MOCK = true below.
//   2. Place real API response snapshots in _mocks/ (gitignored — never commit visitor data):
//        _mocks/<visits-response>.json   → assign to MOCK_VISITS
//        _mocks/<event-response>.json    → assign to MOCK_CURRENT_EVENT
//        _mocks/<agent-response>.json    → assign to MOCK_AGENT_DATA
//   3. Import them here with `import visitsData from '../../_mocks/...'` etc.
//      (imports are commented out when not in use so the build works without the folder)
//
// The _mocks/ folder is gitignored. Populate it locally from real API responses.

import type { VisitHistoryEvent, VisitHistoryResponse } from '../types/visitHistory'

export const USE_DEMO_MOCK = false

export const MOCK_VISITS: VisitHistoryResponse = { events: [] }
export const MOCK_CURRENT_EVENT: VisitHistoryEvent = { event_id: '', timestamp: 0, identification: {} }
export const MOCK_AGENT_DATA: { visitor_id: string } = { visitor_id: '' }
